import { defineComponent as _defineComponent } from 'vue'
import { onMounted, reactive, ref } from "vue";
import { email, minLength, required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { getClientInstance } from "@/services/client/clientProvider";
import { getRolesOptions } from "@/services/roles/utils";

export interface FormStateModel {
  firstname: string;
  lastname: string;
  surname: string;
  email: string;
  password: string;
  phone: string;
  roles: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateCompanyUserForm',
  props: {
    companyId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  companyId?: number;
}



const roleOptions = ref<{ text: string; value: string }[]>([]);

const formState = reactive<FormStateModel>({
  firstname: "",
  lastname: "",
  surname: "",
  email: "",
  password: "",
  phone: "",
  roles: ["ROLE_USER"],
});

const rules: { [key in keyof FormStateModel]?: any } = {
  firstname: { required },
  lastname: { required },
  surname: { required },
  email: { required, email },
  password: { required },
  phone: { required, minLength: minLength(12) },
};

const v = useVuelidate(rules, formState);

onMounted(async () => {
  roleOptions.value = getRolesOptions(
    await getClientInstance().getAvailableUserRoles({
      forSubcompanyUsers: !!props.companyId,
    })
  );
});

function validateState(field: { $dirty: boolean; $invalid: boolean }) {
  const { $dirty, $invalid } = field;
  return $dirty ? !$invalid : null;
}

async function getFormData(): Promise<FormStateModel> {
  await v.value.$validate();
  if (!v.value.$invalid) {
    return JSON.parse(JSON.stringify(formState));
  } else {
    throw new Error("Form validation failed");
  }
}

function resetFormValidationState() {
  v.value.$reset();
}

expose({ getFormData, resetFormValidationState });

return { __sfc: true,props, roleOptions, formState, rules, v, validateState, getFormData, resetFormValidationState, email }
}

})